import React from "react"
import PropTypes from "prop-types"
import Card from "../card"
import { P, H2 } from "../typography"
import Separator from "../separator"
import { Data, Datum, Key, Value } from "./styles"

const BalanceBadge = ({ balance, useAltNegative = false }) => {
  if (balance.toString() === "$0.00") {
    return <Value variant="secondaryReadable">{balance}</Value>
  } else {
    if (balance.toString().includes("-")) {
      return (
        <Value variant="secondaryReadable" positive={balance.toString()}>
          {balance}
        </Value>
      )
    } else if (useAltNegative) {
      return (
        <Value variant="secondaryReadable" altNegative={balance.toString()}>
          {balance}
        </Value>
      )
    } else {
      return (
        <Value variant="secondaryReadable" negative={balance.toString()}>
          {balance}
        </Value>
      )
    }
  }
}

const EmployerFinancialOverview = ({
  employerName,
  totalCosts,
  totalDiscounted,
  totalPaid,
  balance,
  invoicedBalance
}) => (
  <Card variant="secondary">
    <P size="small" marginless variant="secondaryReadable">
      {employerName}
    </P>
    <H2 size="large" marginless variant="secondaryReadable">
      Account Overview
    </H2>
    <Separator size="small" mobileOnly={false} variant="secondaryReadable" />

    <Data>
      <Datum>
        <Key variant="secondaryReadable">Total Costs</Key>
        <Value variant="secondaryReadable">{totalCosts}</Value>
      </Datum>
      <Datum>
        <Key variant="secondaryReadable">Total Discounted</Key>
        <Value variant="secondaryReadable">{totalDiscounted}</Value>
      </Datum>
      <Datum>
        <Key variant="secondaryReadable">Total Paid</Key>
        <Value variant="secondaryReadable">{totalPaid}</Value>
      </Datum>
      <Datum>
        <Key variant="secondaryReadable">Total Balance Due</Key>
        <BalanceBadge balance={balance} />
      </Datum>
      <Datum>
        <Key variant="secondaryReadable">Invoiced Balance</Key>
        <BalanceBadge balance={invoicedBalance} useAltNegative={true} />
      </Datum>
    </Data>
  </Card>
)

EmployerFinancialOverview.propTypes = {
  employerName: PropTypes.string.isRequired,
  totalCosts: PropTypes.string.isRequired,
  totalDiscounted: PropTypes.string.isRequired,
  totalPaid: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
  invoicedBalance: PropTypes.string.isRequired
}

EmployerFinancialOverview.defaultProps = {
  employerName: "",
  totalCosts: "",
  totalDiscounted: "",
  totalPaid: "",
  balance: "",
  invoicedBalance: ""
}

export default EmployerFinancialOverview
